import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { PointsService} from '../../services/points.service';
import { RoutesService} from '../../services/routes.service';
import { RouteService} from '../../services/route.service';
import { CommonService } from '../../services/common.service';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Observable} from 'rxjs/Observable';
import {any} from "codelyzer/util/function";
import { AlertService} from '../../services/alert.service';
import swal from 'sweetalert2';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { ExcelService } from '../../services/excel.service';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;



@Component({
  selector: 'app-controlpoints',
  templateUrl: './controlpoints.component.html',
  styleUrls: ['./controlpoints.component.css']
})
export class ControlpointsComponent implements OnInit {
  points: any = [];

  pointTypes: any = [];
  selectedpointTypes = [];
  pointTypesSettings = {};
  filterMenuVisible: boolean = false;
  displayedColumns: string[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private routesService: RoutesService,
    private routeService: RouteService,
    private pointsService: PointsService,
    private commonService: CommonService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private excelService: ExcelService,
  ) { }

  ngOnInit() {
    this.pointTypesSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };



    this.getControlPoints();
    this.getControlPointTypes()
  }

  applyFilter(filterValue: string) {
    this.points.filter = filterValue.trim().toLowerCase();

    if (this.points.paginator) {
      this.points.paginator.firstPage();
    }
  }

  sortData(e){
    console.log(e)
  }

  setTable(data){
    this.displayedColumns = ["Name", "Address", "Type", "Edit","Delete"];
    this.points = new MatTableDataSource(data);
    this.points.paginator = this.paginator;
    this.points.paginator._intl.itemsPerPageLabel = "Filas por Página:"
    this.points.sort = this.sort;
    // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
    $(".mat-paginator-page-size").css("display", "none")
  }


  getControlPoints(){
    let that = this;
    this.pointsService.getPointByUser(this.commonService.getUserName()).then(response => {
      // this.points =response;
      that.setTable(response)
    });
  }

  filterControlPoints(){
    let that = this;
    var typesId = this.selectedpointTypes.map(({ id }) => "'" + id + "'").toString();
    
    if(typesId != ""){
      this.pointsService.getPointByUser_filtered(this.commonService.getUserName(), typesId).then(response => {
        console.log(response);
        this.points =response;
        that.setTable(this.points)
      });
    }
  }


  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }
  getControlPointTypes(){
    this.pointsService.getCtrlPointTypes().then(response => {
      console.log(response)
      this.pointTypes = response;
    });

  }

  removeCtrlPt(id){
     //var id=this.points[index].id;
     
     console.log(id);
     let that = this;
    swal({
      title: '¿Esta seguro de borrar el punto de control seleccionado?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#ff5370',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(function (s) {
      console.log(s);
     if(s.dismiss !== undefined){
       if (s.dismiss.toString() === 'cancel') {
       }
     }else{
       if(s.value!== undefined){
          if(s.value){
            that.pointsService.deletePoint(id).then(response => {
                if (response){
                  if (response.status == 'EXITO') {
                    // that.points.splice(index, 1);
                    location.reload()
                    swal({
                      title: response.message,
                      text: '',
                      type: 'success'
                     }).catch(swal.noop);
                  } else {
                    //that.alertService.error(response.mensaje);
                  }
                }
            });
          }
       }
     }
   }).catch(swal.noop);
  }


  exportToExcel() {

    var data = []

    console.log(this.points.data)
    for(var i in this.points.data){
      data.push({
        Nombre : this.points.data[i].name,
        Direccion : this.points.data[i].address,
        Tipo : this.points.data[i].typename,
      })
    }

    if (data.length > 0) {
      this.excelService.exportAsExcelFile(data, 'Puntos de Control');
    } else {
      swal({
        title: 'No hay datos para exportar',
        text: '',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/controlpoints/controlpoints.component.ts